module.exports = __webpack_public_path__ + "img/jzhaocai.77387f39.gif";